import React from "react";

export default function PrivacyPage() {
  return (
    <div
      className=""
      style={{
        margin: "80px",
        marginTop: "25px",
        marginLeft: "auto",
        marginRight: "auto",
        maxWidth: "900px",
      }}
    >
      <>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta charSet="utf-8" />
        <title> </title>
        <style
          dangerouslySetInnerHTML={{
            __html:
              '\n      body {\n        font-family: Calibri;\n        font-size: 12pt;\n      }\n      h1,\n      h2,\n      h3,\n      h5,\n      p {\n        margin: 0pt;\n      }\n      li {\n        margin-top: 0pt;\n        margin-bottom: 0pt;\n      }\n      h1 {\n        margin-top: 5pt;\n        margin-bottom: 5pt;\n        page-break-inside: auto;\n        page-break-after: auto;\n        font-family: "Times New Roman";\n        font-size: 24pt;\n        font-weight: bold;\n        color: #000000;\n      }\n      h2,\n      .Signatories {\n        margin-left: 216pt;\n        text-indent: 18pt;\n        page-break-inside: auto;\n        page-break-after: avoid;\n        widows: 0;\n        orphans: 0;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n        font-weight: normal;\n        color: #000000;\n      }\n      h3 {\n        margin-top: 5pt;\n        margin-bottom: 5pt;\n        page-break-inside: auto;\n        page-break-after: auto;\n        font-family: "Times New Roman";\n        font-size: 13.5pt;\n        font-weight: bold;\n        color: #000000;\n      }\n      h5,\n      .BoardSignatureLines {\n        text-indent: 216pt;\n        text-align: justify;\n        page-break-inside: auto;\n        page-break-after: avoid;\n        widows: 0;\n        orphans: 0;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n        font-weight: normal;\n        color: #000000;\n      }\n      .BoardResolution {\n        margin-left: 72pt;\n        margin-bottom: 0pt;\n        text-indent: -72pt;\n        text-align: justify;\n        widows: 0;\n        orphans: 0;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n      }\n      .BodyTextIndent {\n        margin-left: 18pt;\n        margin-bottom: 6pt;\n        font-size: 12pt;\n      }\n      .CommentSubject {\n        font-size: 10pt;\n        font-weight: bold;\n      }\n      .CommentText {\n        font-size: 10pt;\n      }\n      .Consent {\n        margin-left: 36pt;\n        text-indent: 36pt;\n        text-align: justify;\n        widows: 0;\n        orphans: 0;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n      }\n      .ListParagraph {\n        margin-left: 36pt;\n        font-size: 12pt;\n      }\n      .NormalWeb {\n        margin-top: 5pt;\n        margin-bottom: 5pt;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n      }\n      .NumbertoText {\n        text-align: justify;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n        color: #000000;\n      }\n      .Recital {\n        margin-left: 72pt;\n        margin-bottom: 0pt;\n        text-indent: -72pt;\n        text-align: justify;\n        widows: 0;\n        orphans: 0;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n        text-decoration: underline;\n      }\n      .TableHeading {\n        margin-left: 72pt;\n        text-indent: 36pt;\n        widows: 0;\n        orphans: 0;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n        text-decoration: underline;\n      }\n      .TableList {\n        widows: 0;\n        orphans: 0;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n      }\n      .footercareerslink {\n        margin-top: 5pt;\n        margin-bottom: 5pt;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n      }\n      .header-contact-cta {\n        margin-top: 5pt;\n        margin-bottom: 5pt;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n      }\n      .menu-item {\n        margin-top: 5pt;\n        margin-bottom: 5pt;\n        font-family: "Times New Roman";\n        font-size: 12pt;\n      }\n      span.CommentReference {\n        font-size: 8pt;\n      }\n      span.CommentSubjectChar {\n        font-size: 10pt;\n        font-weight: bold;\n      }\n      span.CommentTextChar {\n        font-size: 10pt;\n      }\n      span.Emphasis {\n        font-style: italic;\n      }\n      span.Heading1Char {\n        font-family: "Times New Roman";\n        font-size: 24pt;\n        font-weight: bold;\n      }\n      span.Heading2Char,\n      span.SignatoriesChar {\n        font-family: "Times New Roman";\n      }\n      span.Heading3Char {\n        font-family: "Times New Roman";\n        font-size: 13.5pt;\n        font-weight: bold;\n      }\n      span.Heading5Char,\n      span.BoardSignatureLinesChar {\n        font-family: "Times New Roman";\n      }\n      span.Hyperlink {\n        text-decoration: underline;\n        color: #0000ff;\n      }\n      span.Strong {\n        font-weight: bold;\n      }\n      span.UnresolvedMention {\n        color: #605e5c;\n        background-color: #e1dfdd;\n      }\n    ',
          }}
        />
        <p
          style={{
            marginBottom: "14pt",
            textAlign: "justify",
            fontSize: "24pt",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ fontFamily: "Montserrat", color: "#000000" }}>Privacy Policy</span>
          </strong>
          <strong>
            <span
              style={{
                width: "141.67pt",
                fontFamily: "Montserrat",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>BrandGen,io, Inc. (“</span>
          <strong>
            <span style={{ color: "#000000" }}>BrandGen</span>
          </strong>
          <span style={{ color: "#000000" }}>,” “</span>
          <strong>
            <span style={{ color: "#000000" }}>we</span>
          </strong>
          <span style={{ color: "#000000" }}>,” “</span>
          <strong>
            <span style={{ color: "#000000" }}>our</span>
          </strong>
          <span style={{ color: "#000000" }}>,” “</span>
          <strong>
            <span style={{ color: "#000000" }}>us</span>
          </strong>
          <span style={{ color: "#000000" }}>” or “</span>
          <strong>
            <span style={{ color: "#000000" }}>company</span>
          </strong>
          <span style={{ color: "#000000" }}>
            ”) is committed to respecting the privacy and security of your personal information. The following privacy
            policy (“
          </span>
          <strong>
            <span style={{ color: "#000000" }}>Privacy Policy</span>
          </strong>
          <span style={{ color: "#000000" }}>”, or “</span>
          <strong>
            <span style={{ color: "#000000" }}>Policy”</span>
          </strong>
          <span style={{ color: "#000000" }}>
            ) describes the information we collect and how we use it. By using this website (“
          </span>
          <strong>
            <span style={{ color: "#000000" }}>Site</span>
          </strong>
          <span style={{ color: "#000000" }}>,” “</span>
          <strong>
            <span style={{ color: "#000000" }}>Platform</span>
          </strong>
          <span style={{ color: "#000000" }}>,” “</span>
          <strong>
            <span style={{ color: "#000000" }}>Website</span>
          </strong>
          <span style={{ color: "#000000" }}>
            ”) or the service offered through our Site or any mobile application (the “
          </span>
          <strong>
            <span style={{ color: "#000000" }}>Service</span>
          </strong>
          <span style={{ color: "#000000" }}>”), you consent to our Privacy Policy.</span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            We may update this Privacy Policy from time to time to reflect material changes in how we collect, use,
            share or store your personal information. We encourage you to refer to this Privacy Policy on an ongoing
            basis so that you understand our then-current Privacy Policy. You consent to any changes we make to this
            Privacy Policy if you continue to use the BrandGen service after receiving a notice of the change or upon
            our posting of the new Privacy Policy on this Site.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>TYPES OF INFORMATION WE COLLECT</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            Like many websites, we gather information about how visitors use our Site. In general, you can visit many of
            our web pages without telling us who you are or revealing any personal information about yourself. We may
            track your visit for trends and statistics, but you will remain anonymous unless you tell us who you are.
            Once you choose to give us your personal information, you are not anonymous to us.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>The following are the types of information we collect:</span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <strong>
              <em>
                <span style={{ fontSize: "12pt" }}>Information you give us:</span>
              </em>
            </strong>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              We receive the information you provide to us when you register for, or otherwise use, the Site such as
              your name, email address, business name, business URL, business industry, business type, phone number,
              address, credit card information and any feedback, questions, or recommendations you provide. If you
              provide information directly to us in other ways, such as by sending us an email or filling out a form, we
              may retain that information and add it with the other information we have collected from you. We may also
              collect information from you that is necessary for our legitimate interests, which will be disclosed to
              you at the time of collection. BrandGen will use this information for the purposes of which it was
              collected.
            </span>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginLeft: "36pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <strong>
              <em>
                <span style={{ fontSize: "12pt" }}>Information from third parties:</span>
              </em>
            </strong>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              We may receive information about you from other sources, such as from friends who refer you to us,
              third-party sites, or services that you link your BrandGen account with, or otherwise. We may add this
              information to the information we have already collected from you.
            </span>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginLeft: "36pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <strong>
              <em>
                <span style={{ fontSize: "12pt" }}>Information shared with third parties:</span>
              </em>
            </strong>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              We may share information about you with other sources, who are both controllers and processors of data
              required for the management or use of the BrandGen platform. BrandGen confirms with all third-parties to
              ensure the data is managed in a lawful manner. Suppliers and service providers are required by contract to
              keep confidential the information received on our behalf, and may not use it for any purpose other than to
              carry out the services they are performing for us. When we believe in good faith that disclosure is
              necessary to protect our rights, protect your safety or the safety of others, investigate fraud, or
              respond to a government request.
            </span>
          </li>
        </ul>
        <p className="ListParagraph">
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <strong>
              <em>
                <span style={{ fontSize: "12pt" }}>Automatically collected information:</span>
              </em>
            </strong>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              To make our Site and Services more useful to you, our servers (which may be hosted by a third-party
              service provider) may collect information from you, including browser type, operating system, Internet
              Protocol (IP) address (a number that is automatically assigned to your computer when you use the Internet,
              which may vary from session to session), domain name,
            </span>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>precise location data with GPS or latitude/longitude,</span>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              or a date and time stamp for your visit. We also use Cookies (as defined below) and navigational data to
              gather information regarding the date and time of your visit and the solutions and information for which
              you searched and which you viewed. Like most Internet services, we automatically gather this information
              and store it in log files each time you visit our Site or access your account on our network. “
            </span>
            <strong>
              <span style={{ fontSize: "12pt" }}>Cookies</span>
            </strong>
            <span style={{ fontSize: "12pt" }}>
              ” are small pieces of information that a Site sends to your computer’s hard drive while you are viewing a
              website. Cookies are refreshed from the last time we see a user in order to retain up-to-date information.
              We may use both session Cookies (which expire once you close your web browser) and persistent Cookies
              (which stay on your computer until you delete them) to provide you with a more personal and interactive
              experience on our Site. Persistent Cookies can be removed by following Internet browser help file
              directions. If you choose to disable cookies, some areas of our Site or portions of the Service may not
              work properly. We also could use data from mobile applications, including advertising IDs and mobile
              device IDs, to gather information regarding the date and time of your visit and the solutions and
              information for which you searched and which you viewed. Mobile advertising IDs or Mobile Device IDs are a
              unique identifier which can be used to identify a mobile device. Mobile applications and networks assign
              unique identifiers for mobile app developers can identify who is using their mobile apps as well as use
              for advertising purposes. We interpret engaging with our brand as an indication of your interest in our
              products and services, and thus providing consent for this data collection. Forms of engagement can be
              best exemplified by visiting our site, following us on social media, or interacting with our other
              marketing channels.
            </span>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginLeft: "36pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <strong>
              <em>
                <span style={{ fontSize: "12pt" }}>Information collected through our service:</span>
              </em>
            </strong>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              Our service allows our clients to collect information about their current or potential customers using
              cookies, pixel tags, web beacons, web bugs,
            </span>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              televisions or OTT devices, and other collection technologies. While we do not collect this information on
              our site, we want you to be aware of how our services can be used to collect your information using
              publicly available data and other collection technologies. Our clients may provide us with various data
              sets that typically reside within their customer resource management databases (which may include names,
              emails, addresses, or phone numbers), which we enable, on their behalf, and help link to applications that
              they use. We may also collect your location information, such as your zip code or the approximate
              geographic area derived from your IP address or location positioning information provided by the location
              services and GPS features of your mobile device when location services have been enabled.
            </span>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>
              We also source matched or linked data that enables our clients to pseudonymously match users across
              channels. The matched or linked data comes from reputable data providers, brands, and websites with the
              rights to share consumer data. We combine and measure these data sets against each other to ensure a high
              level of accuracy. When a consumer visits one of our match partner sites (such as a popular website), that
              partner sends us a unique identifier that has been de-identified using a hashing algorithm. We then search
              our database of client data to determine whether any of our clients is requesting to match data for that
              particular consumer. If a match occurs, we associate a cookie with de-identified data about the consumer
              on behalf of our clients based on the last time we saw a user. Clients can then reach our matched
              non-personally identifiable users with relevant messages and advertisements. They may also use this data
              for measurement purposes such as understanding how digital advertising spend impacts purchasing on their
              Site. Sometimes, we use our mobile cookie or mobile ID data alongside our web-based cookie data, to help
              other platforms to “match” or “map” users they have already “seen” across multiple web and mobile
              platforms, on a de-identified basis. This collected data may be used for personalized
            </span>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>advertising or ad delivery and reporting.</span>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>USING INFORMATION</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We use and disclose your personal information only as described in this Policy or as otherwise disclosed to
            you on our Sites. By registering for our products and services, or engaging with our brand, you provide us
            consent to collect and use your personal information to provide an enhanced experience with us.{" "}
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>For example, we may use or disclose your personal information:</span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>To operate and improve our Sites;</span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>To fulfill your requests for certain products or services;</span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              To provide you with content and information relevant to your interests in our product and services to
              facilitate and enhance your use of the platform;
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              To better understand your needs and provide you with more customized service;
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              To communicate with you about the Sites or our products and services;
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>To respond to any questions or concerns that you may have;</span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              For market research, project planning, troubleshooting problems, detecting and
            </span>
            <span style={{ fontSize: "12pt" }}>&nbsp;</span>
            <span style={{ fontSize: "12pt" }}>protecting against errors, fraud, or other criminal activity;</span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              To third-party contractors that provide services to us and are contractually bound to safeguard your
              personal information (i.e. credit card processors);
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              To third parties in connection with any merger, acquisition, reorganization, change in capital structure
              or sale of all or substantially all of the assets of BrandGen.
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              When we have a good faith belief that disclosure is necessary to comply with the law, protect or defend
              our rights or the rights of other users of our Sites or products or services, or act in an emergency to
              protect someone’s safety; or
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>Otherwise with your express consent.</span>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We may create non-personally identifying anonymous or aggregate data from the information we collect. We may
            use that data that is non-personally identifiable, pseudonymous or aggregate data for our own purposes or
            disclose it to third parties in our own discretion.
          </span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <em>
            <span style={{ color: "#000000" }}>Do Not Track.</span>
          </em>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            We do not respond to browser-based “do not track” signals. We do not have any third-party sites who push
            content to our site.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>PROTECTING YOUR INFORMATION</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We have implemented commercially reasonable security measures, including physical, electronic, and
            administrative safeguards, to prevent unauthorized access to, loss, misuse, or alteration of the information
            collected through our Websites.
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            We take reasonable steps to help protect your personal information in an effort to prevent loss, misuse,
            unauthorized access, disclosure, alteration, and destruction. We follow generally accepted standards to
            protect the personal information submitted to us, both during transmission and once we receive it. However,
            no method of transmission over the Internet, or method of electronic storage is 100% secure.
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            We make no assurances in this policy about our ability to prevent such loss, misuse, to you or to any
            third-party arising out of any such loss, misuse, or alteration. If you have any questions about the
            security of our Sites you can contact us using the information provided below.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>RETENTION</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We retain the PII you provide to us for as long as your account is active or as needed to provide you
            services or perform the purposes for which it was supplied. We will retain and use your PII as necessary to
            comply with our legal obligations, resolve disputes, and enforce our agreements.
          </span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000", backgroundColor: "#F9F9F9" }}>
            We retain the pseudonymous data collected on our Websites for up to 12 months. After 12 months (or sooner)
            the data is de-identified or aggregated and stored for up to 3 additional years.
          </span>
        </p>

        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>THIRD PARTIES</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            The Site may contain links, content, and advertisements from third parties. Such links, content, and
            advertisements are not endorsements, authorizations or representations of our affiliation with that third
            party. We are not responsible for the privacy practices or the content of third parties, and we encourage
            you to carefully review the privacy policy of any website you visit.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            The Site may contain content or pixels from third-party providers, including analytics, social media and ad
            tech partners. We may allow certain third parties to collect data about your web viewing behavior on Company
            Websites and combine this data with information collected from other websites over time for purposes that
            include interest-based advertising.
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            There are other limited circumstances in which we may share data. We may provide access to the non-personal
            information we collect to service providers who are assisting us with storage, analysis, or other services.
            These service providers are subject to confidentiality restrictions and are not authorized to utilize the
            information in any way other than to provide their services to us.
          </span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            We want you to feel confident using the Site, but we cannot ensure or warrant the security of any
            information you transmit to us.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>
              INFORMATION COLLECTED THROUGH THE USE OF OUR PLATFORM ON THIRD-PARTY SITES
            </span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            Our technology platform, branded “BrandGen” enables companies to gain unique insights about their website
            visitors, social networks, customers and prospects, and to deliver relevant advertising and content to their
            browsers.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            Advertising agencies, advertising networks, and other companies who may place advertisements through our
            Service (but not on our Site) may use their own cookies, pixel tags, web beacons, web bugs, mobile IDs,
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>precise location data, TV/OTT viewership,</span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            user IDs and other technology to collect information about you. We do not control these companies’ use of
            such technology and we have no responsibility for the use of such technology by these companies to gather
            information about you.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            YOU SHOULD REVIEW THE PRIVACY POLICY AND TERMS OF USE FOR ANY SITE YOU VISIT TO LEARN ABOUT WHAT INFORMATION
            THOSE SITES COLLECT FROM YOU, AND HOW THEY USE AND SHARE SUCH INFORMATION. THE INFORMATION IN THIS PARAGRAPH
            MAY NOT REFLECT WHAT OUR CLIENTS OR WE COLLECT ON ANY PARTICULAR SITE.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We and our clients collect, organize, and use non-personally identifiable information reflecting your
            interactions with a variety of websites, media types and social networks. This information includes items
            such as the date and time you visited a website, your browser information, your IP address, your
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>precise location data, your TV/OTT viewing behavior,</span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            your browsing behavior, your age and gender, and interests you express or imply at social networking sites
            or other websites you visit. BrandGen or its clients may recognize your computer over time by setting a
            unique browser “cookie” or “mobile ID,” which your browser relays to our servers when you visit websites
            that are affiliated with our partners or clients. We and our clients may also supplement the information we
            collect with additional non-personally identifiable information we obtain from other companies. In certain
            of these cases, the information we or our clients obtain from third parties is derived from personal
            information and de-identified prior to its use. We analyze the non-personal information we collect or obtain
            from third parties and organize it into pseudonymous user profiles, groups, and audiences, based on factors
            such as age, gender, geography, interests, offline and online actions. We and our clients and partners then
            use these pseudonymous user profiles, groups, and audiences to design and deliver customized advertising
            campaigns or other relevant content. We and our clients also use this data for other related purposes (for
            example, to do research regarding the results of our online advertising campaigns or to better understand
            the interests or activities of website visitors.)
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            The behavioral categories we use to customize the ads you may see or for related purposes do not use
            personally identifiable information (PII) such as your name, address, e-mail address, phone number, birth
            date, or social security number. Our technology and services are designed to limit our use of consumer data
            to pseudonymous, non-personal information. Note that we license BrandGen to third parties, such as website
            publishers and marketers. A third-party licensee using BrandGen may elect to collect, manage, and use other
            types of data through BrandGen, which may include personal information (where permissible). Please consult
            the privacy policies of the websites you visit to become familiar with their privacy practices.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            You can configure your web browser (Chrome, Firefox, Internet Explorer, Safari, etc.) to delete and/or
            control the use of cookies. More information can be found in the Help system of your browser.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            When you visit a website that shares information about your activity with BrandGen, we will use that
            information to customize relevant ads to you at that and other websites you visit, or for research and
            analysis. We may also share non-personal information with companies such as advertisers, agencies, ad
            networks, or exchanges to enable them to analyze user behaviors or to customize the ads that you encounter.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            In addition, to comply with the California Consumer Privacy Act (CCPA), BrandGen must include details on the
            opt out of the sale of personal information by some or all of the participating companies.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>HOW TO REVIEW, MODIFY OR DELETE YOUR INFORMATION</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We want to communicate with you only if you want to hear from us. If you prefer not to receive information
            from us or would like to update or change your personal information or preferences, follow the instructions
            below to review, modify or delete your personal information.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            To modify the information you have provided during registration, please log in and update your personal
            settings.
          </span>
        </p>
        <ul style={{ margin: "0pt", paddingLeft: "0pt" }}>
          <li
            style={{
              marginTop: "14pt",
              marginLeft: "27.6pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              To unsubscribe from a promotional email, please follow the instructions or unsubscribe links available in
              any email you receive. If you decide not to receive promotional emails, we may still send you
              transactional communications, such as those about your account, to fulfill orders you have made, or to ask
              you to rate a product you purchased.
            </span>
          </li>
          <li
            style={{
              marginLeft: "27.6pt",
              marginBottom: "14pt",
              textAlign: "justify",
              paddingLeft: "8.4pt",
              fontFamily: "serif",
              fontSize: "10pt",
              color: "#000000",
              backgroundColor: "#F9F9F9",
            }}
          >
            <span style={{ fontSize: "12pt" }}>
              If you request your registration information be deleted or if you unsubscribe from communications, we may
              maintain information about sales transactions or service inquiries for future service and record keeping
              purposes.
            </span>
          </li>
        </ul>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            In addition, you can configure your web browser (Chrome, Firefox, MS Edge Safari, etc.) to delete and/or
            control the use of cookies. More information can be found in the Help system of your browser.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We may need to retain certain information for recordkeeping purposes, as required under applicable legal
            obligations, or to complete any transactions that you began prior to requesting such change or access. When
            updating or deleting your information, we may ask you to verify your identity before we can act on your
            request. We will comply with your request as soon as reasonably practicable and in accordance with
            applicable laws.
          </span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            We generally retain your personally identifiable information as long as necessary in order to provide you
            with our services, but after one (1) year we will not use your information for any interest-based
            advertising or ad delivery.
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            We may retain anonymized or aggregated data generated from your information indefinitely.
          </span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <strong>
            <span style={{ color: "#000000" }}>&nbsp;</span>
          </strong>
        </p>
        <p style={{ backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            We welcome your questions, comments, and concerns about privacy. Please contact us via email at:
          </span>
          <br />
          <a href="mailto:privacy@BrandGen.io" style={{ textDecoration: "none" }}>
            <u>
              <span style={{ color: "#0c7c9c", backgroundColor: "#F9F9F9" }}>
                <span className="__cf_email__" data-cfemail="b1c1c3d8c7d0d2c8f1f3c3d0dfd5f6d4df9fd8de">
                  privacy@BrandGen.io
                </span>
              </span>
            </u>
          </a>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>A NOTE TO USERS OUTSIDE OF THE UNITED STATES</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            BrandGen is based, and the Platform is hosted, in the United States of America. If you are from a country
            outside of the United States of America with laws governing data collection, use, and disclosure that may
            differ from U.S. law and you provide personal
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            information to us, please note that any personal information that you provide to us may be transferred to
            the United States of America. By providing your personal information, you hereby specifically and expressly
            consent to such transfer and processing and the collection, use, and disclosure set forth herein or in the
            Terms of Service to the extent permitted by applicable law.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>CALIFORNIA VISITORS</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            As it relates to personal data collected on this site for Residents of the State of California, as outlined
            in the
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <a href="https://oag.ca.gov/privacy/ccpa" style={{ textDecoration: "none" }}>
            <u>
              <span style={{ color: "#0c7c9c" }}>California Consumer Privacy Act (CCPA</span>
            </u>
          </a>
          <span style={{ color: "#000000" }}>), you are granted:</span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textIndent: "36pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>(a) the right to access;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textIndent: "36pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>(b) the right to restrict processing, opt-out;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textIndent: "36pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>(c) the right to object to processing, do not sell;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textIndent: "36pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>(d) the right to disclosure of intent and third parties; and</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textIndent: "36pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>(e) the right to withdraw consent.</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            Residents of the State of California may request access to any personally identifiable data that is
            collected through the BrandGen Site. This includes a list of all third parties to which a BrandGen Site has
            disclosed certain information during the preceding year for the third parties’ direct marketing purposes.
            The BrandGen Site does not explicitly sell any personally identifiable data to other businesses or third
            parties for monetary or other valuable consideration. In the normal course of business and direct marketing
            purposes, anonymous non-PII cookies are shared between providers to execute digital advertising.
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            For California residents that want access to a list of the data, a list of third-parties used, and opt-out
            of processing and selling, please contact us at
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <a href="mailto:privacy@BrandGen.io" style={{ textDecoration: "none" }}>
            <span className="Hyperlink" style={{ color: "#0070c0", backgroundColor: "#F9F9F9" }}>
              <span className="__cf_email__" data-cfemail="1363617a6572706a535161727d7754767d3d7a7c">
                privacy@BrandGen.io
              </span>
            </span>
          </a>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            For all requests, you must put the statement “Your California Privacy Rights” in the body of your request
            and include the name of the Site with respect to which you are requesting the information, as well as your
            name, street address, city, state, and zip code. Please note that we will not accept requests via the
            telephone, mail, or by facsimile, and we are not responsible for notices that are not labeled or sent
            properly, or that do not have complete information.
          </span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>CALIFORNIA VISITORS</span>
          </strong>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            Residents of the State of California may request a list of all third parties to which a BrandGen Site has
            disclosed certain information during the preceding year for the third parties’ direct marketing purposes. If
            you are a California resident and want such a list, please contact us at
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>

          <a href="mailto:privacy@BrandGen.io" style={{ textDecoration: "none" }}>
            <span className="Hyperlink" style={{ color: "#0070c0", backgroundColor: "#F9F9F9" }}>
              <span className="__cf_email__" data-cfemail="49393b203f282a30090b3b28272d0e2c27672026">
                privacy@BrandGen.io
              </span>
            </span>
          </a>

          <span style={{ color: "#2f5496" }}>. </span>
          <span style={{ color: "#000000" }}>
            For all requests, you must put the statement “Your California Privacy Rights” in the body of your request
            and include the name of the Site with respect to which you are requesting the information, as well as your
            name, street address, city, state, and zip code. Please note that we will not accept requests via the
            telephone, mail, or by facsimile, and we are not responsible for notices that are not labeled or sent
            properly, or that do not have complete information.
          </span>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>

        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>DISPUTE RESOLUTION</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            If you have any questions or concerns, please contact Company by e-mail at{" "}
            <a
              href="/cdn-cgi/l/email-protection"
              className="__cf_email__"
              data-cfemail="f484869d8295978db4b686959a90b3919ada9d9b"
            >
              privacy@BrandGen.io
            </a>
            . We will do our best to address your concerns
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>and we will process your request within 30 days of receiving it.</span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>
            If you feel that your complaint has been addressed incompletely, we invite you to let us know for further
            investigation. If you and Company are unable to reach a resolution to the dispute, you and Company will
            settle the dispute exclusively as set forth in the Terms of Service.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>CHANGES TO OUR POLICY</span>
          </strong>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            We may revise this policy at any time. Any changes and/or updates to the policy will be updated directly on
            this page. Material changes to this policy will be enacted on a going-forward basis.
          </span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>EUROPEAN VISITORS</span>
          </strong>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>
            In accordance with applicable laws, you may have the right to request access to, rectification, and erasure
            of your personal information; restriction of processing of personal information; objecting to certain
            processing of personal information; and the right to data portability. Where any processing of personal
            information is solely dependent upon your consent, you have the right to withdraw such consent at any time
            (For example, we suggest by using the unsubscribe link contained in an applicable marketing message or
            emailing us at
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <a href="mailto:privacy@BrandGen.io" style={{ textDecoration: "none" }}>
            <span className="Hyperlink" style={{ backgroundColor: "#F9F9F9" }}>
              <span className="__cf_email__" data-cfemail="3b4b49524d5a58427b79495a555f7c5e55155254">
                privacy@BrandGen.io
              </span>
            </span>
          </a>

          <span style={{ color: "#000000" }}>
            {" "}
            Where you believe that we have not processed your personal information in accordance with applicable laws,
            you may lodge a complaint with the respective supervisory authority or data protection regulator. The
            provision of personal information by you will be for contractual, marketing, analytical purposes, or other
            purposes as referred to in this Policy. When we receive your request, we may ask you to verify your identity
            before we can act on your request. We may withhold information where we are required by law to do so or if
            the search for that information would require disproportionate effort or have a disproportionate effect to,
            for example, the cost of providing the information, the time it would take to retrieve the data, or how
            difficult it may be to obtain the information requested. Additional specific requests of data collection,
            management or use may be directed to us at
          </span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <a href="mailto:privacy@BrandGen.io" style={{ textDecoration: "none" }}>
            <span className="Hyperlink" style={{ backgroundColor: "#F9F9F9" }}>
              <span className="__cf_email__" data-cfemail="1a6a68736c7b79635a58687b747e5d7f74347375">
                privacy@BrandGen.io
              </span>
            </span>
          </a>
          <span style={{ color: "#000000" }}>.</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>TERMS OF SERVICE</span>
          </strong>
        </p>
        <p style={{ textAlign: "justify", backgroundColor: "#F9F9F9" }}>
          <span style={{ color: "#000000" }}>Please also visit our Terms of Service at</span>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <a href="https://app.brandgen.io/terms-of-use" style={{ textDecoration: "none" }}>
            <span className="Hyperlink" style={{ backgroundColor: "#F9F9F9" }}>
              https://app.brandgen.io/terms-of-use
            </span>
          </a>
          <span style={{ color: "#000000" }}>&nbsp;</span>
          <span style={{ color: "#000000" }}>that explains other terms governing the use of our website.</span>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>QUESTIONS AND FEEDBACK</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We welcome your questions, comments, and concerns about privacy. Please contact us via email at:
          </span>
          <br />
          <a href="mailto:privacy@BrandGen.io" style={{ textDecoration: "none" }}>
            <u>
              <span style={{ color: "#0c7c9c", backgroundColor: "#F9F9F9" }}>
                <span className="__cf_email__" data-cfemail="f9898b908f989a80b9bb8b98979dbe9c97d79096">
                  privacy@BrandGen.io
                </span>
              </span>
            </u>
          </a>
        </p>

        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <strong>
            <span style={{ color: "#000000" }}>COMPLAINTS</span>
          </strong>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>
            We are committed to working with you to obtain a fair resolution of any privacy concern. If you have a data
            privacy complaint, please contact us via email at:
          </span>

          <br />
          <a href="mailto:privacy@BrandGen.io" style={{ textDecoration: "none" }}>
            <u>
              <span style={{ color: "#0c7c9c", backgroundColor: "#F9F9F9" }}>
                <span className="__cf_email__" data-cfemail="f787859e8196948eb7b585969993b09299d99e98">
                  privacy@BrandGen.io
                </span>
              </span>
            </u>
          </a>
        </p>
        <p
          style={{
            marginTop: "14pt",
            marginBottom: "14pt",
            textAlign: "justify",
            backgroundColor: "#F9F9F9",
          }}
        >
          <span style={{ color: "#000000" }}>&nbsp;</span>
        </p>
      </>
    </div>
  );
}
